module.exports = __webpack_public_path__ + "static/media/emily-addison-icon.abaa0d46.jpg";